import { DateService } from './../../_services/date.service';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OfferService } from '../../_services/offer.service';
import { CompanyService } from '../../_services/company.service';
import { PlaceService } from '../../_services/place.service';
import { FormGroup, FormControl } from '@angular/forms';
declare var jQuery: any;
import '../../../assets/semantic/semantic.min.js';
import { IMyDpOptions } from 'mydatepicker';
import { PlanningService } from '../../_services/planning.service';

@Component({
  selector: 'app-offer',
  templateUrl: './offer.component.html',
  styleUrls: ['./offer.component.css']
})
export class OfferComponent implements OnInit {
  // page param (stored in URL)
  private page_param: string;
  private offers: object[];
  private offers_count: number;
  private page_number: number;
  private page_count: number;
  private page_indicators: number[];

  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'dd/mm/yyyy',
    openSelectorOnInputClick: true,
    editableDateField: false
  };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private service: OfferService,
    private company_service: CompanyService,
    private place_service: PlaceService,
    private planning_service: PlanningService,
    private date_service: DateService
  ) { }

  filters = new FormGroup({
    seller: new FormControl(),
    departure_city: new FormControl(),
    departure_area: new FormControl(),
    departure_country: new FormControl(),
    arrival_city: new FormControl(),
    arrival_area: new FormControl(),
    arrival_country: new FormControl(),
    vehicle: new FormControl(),
    quantity: new FormControl(''),
    departure_date: new FormControl(),
    arrival_date: new FormControl(),
    buy_price: new FormControl(''),
    sell_price: new FormControl('')
  });

  ngOnInit() {

    // Get the Params..
    this.route.queryParams.subscribe(params => {
      this.page_param = params['page'] || 1; // Get Page number Param
    });

    this.filters.valueChanges.debounceTime(500).subscribe(
      (value) => {
        // Check Departure & Arrival places Values:
        // If there is a departure_id city, clear the area & country inputs.
        if (value.departure_city) {
          this.filters.patchValue({ departure_area: null, departure_country: null });
        }
        // If there is a departure_id area, clear the country input
        if (value.departure_area) {
          this.filters.patchValue({ departure_country: null });
        }
        // If there is an arrival_id city, clear the area & country inputs
        if (value.arrival_city) {
          this.filters.patchValue({ arrival_area: null, arrival_country: null });
        }
        // If there is an arival area, clear the country input.
        if (value.arrival_area) {
          this.filters.patchValue({ arrival_country: null });
        }

        if (value.departure_date && value.departure_date.formatted) this.filters.patchValue({ departure_date: value.departure_date.formatted })
        if (value.arrival_date && value.arrival_date.formatted) this.filters.patchValue({ arrival_date: value.arrival_date.formatted })
        this.router.navigate(['/offers'], { queryParams: { page: '1' } })
        this.refresh();
      }
    )

    this.refresh();

  }

  refresh() {
    let params = {};
    Object.assign(params, this.filters.value, { page: this.page_param });
    this.service.getOffers(params)
      .subscribe(response => {
        this.page_number = parseInt(response.page);
        this.offers_count = parseInt(response.total_count);
        this.offers = response.offers;
        this.page_count = Math.ceil(this.offers_count / 25);   // Page Count
        response.offers.forEach(function (offer) {
          this.service.getMatchingDemands(offer.id).subscribe(res => {
            Object.assign(offer, { matching_count: res.total_count });
          })
        }.bind(this));
        // Page Indicators (for ngFor iterations)
        if (this.page_count < 10) {
          this.page_indicators = Array(this.page_count).fill(1);
        } else {
          this.page_indicators = Array(10).fill(1)
        }
      });
  }

  addToPlanning(offer) {
    var new_planning = Object.assign({}, offer);
    Object.assign(new_planning, { transporter_id: offer.seller }); // Set the receiver_id as seller
    // Set Dates values correctly
    new_planning.departure_date = this.date_service.myDateFormatted(offer.departure_date);
    if (offer.arrival_date) new_planning.arrival_date = new Date(offer.arrival_date)

    this.planning_service.createPlanning(new_planning).subscribe(response => {
      this.service.updateOffer(offer.id, { planned: true }).subscribe(response => {
        this.refresh();
      });
    });
  }

  // Previous Page Button
  previousPage() {
    this.router.navigate(['/offers'], { queryParams: { page: this.page_number - 1 } }).then(function () {
      this.refresh();
    }.bind(this));
  }

  // Next Page Button
  nextPage() {
    this.router.navigate(['/offers'], { queryParams: { page: this.page_number + 1 } }).then(function () {
      this.refresh();
    }.bind(this));
  }

  // Go to page n°nb
  toPage(nb: number) {
    this.router.navigate(['/offers'], { queryParams: { page: nb } }).then(function () {
      this.refresh();
    }.bind(this));
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/offer/offer.component.ts